import CUIFloatingButton from 'connect-dot-com-ui-components/Components/CUIButton/CUIFloatingButton';
import { CUIConnectIconWhite } from 'connect-dot-com-ui-components/Components/CUIConnectLogo/CUIConnectLogo';
import { CUIHStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import { trackInteraction } from '../../utils/usageTracker';
import { DownloadAppModal } from './DownloadAppModal';
import useDisclosure from 'connect-dot-com-ui-components/hooks/useDisclosure';
// @ts-expect-error bender-urls aren't typed
import mobileAppQrCode from 'bender-url!../../../images/connect-public-landing-page-sticky-button.svg';
import { useGetStorageValue } from '../../utils/hooks/useGetStorageValue';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useBreakpointValue } from 'connect-dot-com-ui-components/hooks/useBreakpointValue';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function DownloadIOSAppButton() {
  const isMobile = useBreakpointValue({
    base: true,
    md: false
  });
  const {
    value: floatingDownloadButtonDismissed,
    storeValue,
    loading
  } = useGetStorageValue('floating_download_button_dismissed');
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const onDismissButtonClick = () => {
    storeValue('true').then(() => {
      trackInteraction('dismissed download iOS app button');
    }).catch(err => Raven.captureException(err));
  };
  const onOpenDownloadDialogClick = () => {
    trackInteraction('clicked open iOS app download dialog');
    onOpen();
  };
  if (isMobile || loading || floatingDownloadButtonDismissed === 'true') {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DownloadAppModal, {
      qrCodeSrc: mobileAppQrCode,
      isOpen: isOpen,
      onClose: onClose,
      appStoreCampaign: "floating-button-connect-app"
    }), /*#__PURE__*/_jsx(CUIFloatingButton, {
      onButtonClick: onOpenDownloadDialogClick,
      onDismissButtonClick: onDismissButtonClick,
      children: /*#__PURE__*/_jsxs(CUIHStack, {
        spacing: 2,
        children: [/*#__PURE__*/_jsx(CUIConnectIconWhite, {}), /*#__PURE__*/_jsx(CUIText, {
          fontSize: "md",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.Banners.downloadApp.floatingButtonText"
          })
        })]
      })
    })]
  });
}